"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadServerURL = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const state_1 = require("../state");
const loadServerURL = () => {
    const serverURL = (0, pixel_pigeon_1.getEnvironmentVariable)("SERVER_URL");
    if (typeof serverURL !== "string") {
        throw new Error("SERVER_URL environment variable must be a string");
    }
    state_1.state.setValues({ serverURL });
};
exports.loadServerURL = loadServerURL;
